import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TourInfoTranslation } from '@motes-sdk/modules/tour-info/tour-info.translation';
import { Animations } from '@motes-sdk/animations';
import { Mote, MoteType } from '@motes-sdk/models';
import { AutoSub, AutoSubOnDestroy, MoteService } from '@motes-sdk/providers';

export type ShownTourInfo = {
    duration?: boolean;
    length?: boolean;
    city?: boolean;
    startLocation?: boolean;
    price?: boolean;
};

@AutoSubOnDestroy()
@Component({
    selector: 'tour-summary',
    templateUrl: './tour-summary.component.html',
    styleUrls: ['./tour-summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.fadeIn(200)]
})
export class TourSummaryComponent implements OnInit {

    @Input() set tourKey(newTourKey: string) {
        this.updateValues(newTourKey);
    }

    @Input() shownTourInfo: ShownTourInfo = {
        duration: true,
        length: true,
        startLocation: true,
        city: true,
        price: true
    };

    public tour: Mote;
    public storyCountLabel: string = '';
    public priceLabel: string = '';

    // Expose to view
    public MoteType = MoteType;

    constructor(
        private moteService: MoteService,
    ) { }

    ngOnInit(): void {}

    private updateValues(tourKey: string) {
        AutoSub(this).reg['tourSub'] = this.moteService.watchMote(tourKey).subscribe((tour: Mote) => {
            this.tour = tour;
            if(!this.tour) return;
            let tourTranslation = new TourInfoTranslation(this.tour.language, this.tour.duration, this.tour.distance, this.tour.startPlace, this.tour.endPlace, this.tour.storyCount, this.tour.city);
            this.storyCountLabel = `${this.tour.storyCount} ${tourTranslation.getText('stories')}`;
            this.priceLabel = this.tour.price ? this.tour.price + ' DKK' : tourTranslation.getText('free');
        });
    }

}
